import React, { useEffect, useRef, useState } from "react";

const ECGGraph = ({ ecgData }) => {
  return (
    <>
      <h1 className="font-semibold text-lg p-4">Your last ECG </h1>
    <div className="flex flex-col h-auto w-full justify-center items-center">

      <div
        className={` ${
          ecgData?.inference?.alert ? "bg-red-100" : "text-white "
        } flex flex-col gap-2 justify-center items-center mb-4 w-36 h-36 rounded-full border-8 border-white bg-primary`}
      >
        <div className="flex gap-1 items-end text-center font-bold text-4xl  leading-[1]">
          {" "}
          {ecgData?.inference?.extras?.heart_rate?.split(" ")[0]}
          <span className=" text-center font-semibold text-sm lowercase  flex  items-end">
            {ecgData?.inference?.extras?.heart_rate?.split(" ")[1]}
          </span>
        </div>
        <div className=" flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="red"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-7 h-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
            />
          </svg>
          {ecgData?.inference?.alert ? (
            <p className="text-xs font-semibold text-red-700 animate-pulse">
              Critical
            </p>
          ) : (
            <p className="text-xs font-semibold text-white">Normal</p>
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default ECGGraph;
